<app-warehouse-material-operation-table 
    [folderId]="folderStore.folderId()"
    [columns]="columns"
    [tableFrag]="getWarehouseMaterialsFrag"
></app-warehouse-material-operation-table>
